import { useState } from "react";
import { Popover, IconButton, Box, TextField } from "@mui/material";
import { MdCalendarToday } from "react-icons/md";
import React from "react";
import { SimpleCalendar } from "../scholarship-applications/actions/calendar";

const CalendarDropdown = ({ values, setFieldValue }: any) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "calendar-popover" : undefined;

  return (
    <div>
      {/* Button with Calendar Icon */}
      <IconButton onClick={handleClick}>
        <MdCalendarToday size={24} />
      </IconButton>

      {/* Popover Dropdown */}
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
      >
        <Box p={2}>
          <SimpleCalendar
            selectedDate={values.date ? (values.date as Date) : null}
            onChange={(date) => {
              setFieldValue("date", date);
              handleClose(); // Close popover after selecting a date
            }}
            disablePastDates={true}
          />
        </Box>
      </Popover>
    </div>
  );
};

export default CalendarDropdown;
